<ng-template #modal let-modal class="modal-dialog-centered">
    <div class="modal-header">
        <h4 class="modal-title text-center w-100" id="modalLabel">{{ modalTitle | translate }}</h4>
        <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="closeModal()">
        </button>
    </div>
    <div class="modal-body p-1">
        <div *ngIf="loading" class="row" style="height: 30px">
            <app-ui-preloader id="spinner" [display]="loading" [size]="'20px'"></app-ui-preloader>
        </div>

        <!-- <div *ngIf="!loading" id="tab" class="col-md-12">
            <ul ngbNav #tab="ngbNav" [(activeId)]="tabs" class="nav-tabs nav-bordered">
                <ng-container *ngFor="let language of languages; let i = index">
                    <li [ngbNavItem]="i+1">
                        <a ngbNavLink>
                            {{language.description}}
                        </a>

                        <ng-template ngbNavContent>
                            <ng-container *ngTemplateOutlet="language.locale=='pt'?Tab1:Tab2">
                            </ng-container>
                        </ng-template>
                    </li>
                </ng-container>

            </ul>

            <div [ngbNavOutlet]="tab"></div>
        </div> -->
        <ng-container *ngTemplateOutlet="Tab2">
        </ng-container>

        <!-- <ng-template #Tab1>
            <form [formGroup]="artifactForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">

                            <label for="field-3" class="form-label">
                                {{ 'SETTINGS.ARTIFACTS.TYPE' | translate }}
                            </label>
                            <input type="text" class="form-control" id="field-3" formControlName="typePT"
                                [ngClass]="{'is-invalid':submitted && formArtifact.typePT.invalid}" required>

                            <div *ngIf="submitted && formArtifact.typePT.invalid" class="invalid-feedback">
                                <div *ngIf="formArtifact.typePT.errors?.required" i18n>
                                    {{ 'SETTINGS.ARTIFACTS.TYPEREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">

                            <label class="form-label">{{ 'SETTINGS.ARTIFACTS.CUSTOMERTYPE' | translate }}</label>
                            <input type="text" class="form-control" formControlName="customerTypePT"
                                [ngClass]="{'is-invalid':submitted && formArtifact.customerTypePT.invalid}" required>

                            <div *ngIf="submitted && formArtifact.customerTypePT.invalid" class="invalid-feedback">

                                <div *ngIf="formArtifact.customerTypePT.errors?.required" i18n>
                                    {{ 'SETTINGS.ARTIFACTS.CUSTOMERTYPEREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template> -->

        <ng-template #Tab2>
            <form [formGroup]="artifactForm" class="p-2 mt-n2 form">
                <div class="row">
                    <div class="col-md-12">
                        <div class="mb-2">
                            <label class="form-label">{{ 'SETTINGS.ARTIFACTS.TYPE' | translate }}</label>
                            <input type="text" class="form-control" formControlName="typeEN"
                                [ngClass]="{'is-invalid':submitted && formArtifact.typeEN.invalid}" required>

                            <div *ngIf="submitted && formArtifact.typeEN.invalid" class="invalid-feedback">

                                <div *ngIf="formArtifact.typeEN.errors?.required" i18n>
                                    {{ 'SETTINGS.ARTIFACTS.TYPEREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="form-label">{{ 'SETTINGS.ARTIFACTS.CUSTOMERTYPE' | translate }}</label>
                            <input type="text" class="form-control" formControlName="customerTypeEN"
                                [ngClass]="{'is-invalid':submitted && formArtifact.customerTypeEN.invalid}" required>

                            <div *ngIf="submitted && formArtifact.customerTypeEN.invalid" class="invalid-feedback">
                                <div *ngIf="formArtifact.customerTypeEN.errors?.required" i18n>
                                    {{ 'SETTINGS.ARTIFACTS.CUSTOMERTYPEREQUIRED' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-template>

    </div>
    <div class="mt-1 mb-2 d-flex justify-content-center">
        <button *ngIf="this.artifactForm.value == 0 || this.artifactForm.value == null" type="button"
            class="btn btn-primary btn-action btnSaveBottom mt-1 btnSaveMinW2" (click)="save()">
         
            {{'SETTINGS.ARTIFACTS.ADDTYPE' | translate }}
        </button>
        <button *ngIf="this.artifactForm.value != 0 && this.artifactForm.value != null" type="button" class="btn btn-primary btn-action btnSaveBottom mt-1 btnSaveMinW2"
            (click)="save()">
         
            {{'SETTINGS.ARTIFACTS.EDITTYPE' | translate }}
        </button>
    </div>
</ng-template>